import { useSyncExternalStore } from "react";

/**
 * What I may do, as the API told /api/me: the features an admin gave me, or
 * every feature if I am an admin. One store above every component, the way
 * favorites and the player are, so a heart on a card, the Favorites toggle
 * and the Playlists tab all agree about whether I have the feature.
 *
 * Until /api/me has answered, nothing is granted: a button that appears and
 * then vanishes is worse than one that appears a moment late.
 */
let rights = new Set<string>();
const listeners = new Set<() => void>();

export function setRights(list: string[]): void {
  rights = new Set(list);
  for (const l of listeners) l();
}

export function useRights(): { has: (feature: string) => boolean } {
  const snap = useSyncExternalStore(
    (l) => {
      listeners.add(l);
      return () => listeners.delete(l);
    },
    () => rights,
    () => rights,
  );
  return { has: (f) => snap.has(f) };
}
